








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { projectWebservice } from '@/webservices/project';
import type { Project } from '@/models/project';
import ProjectStore from '@/vuex/modules/project/store';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'ProjectChooser',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {},
})
export default class ProjectChooser extends Vue {
    @Getter('project/projects') private projects: Project[];
    @Prop() private experienceView: boolean;

    private mounted() {
        this.loadProjects();
    }

    get selectedProject() {
        return this.$store.getters['project/selectedProject'];
    }

    set selectedProject(value: Project) {
        this.projectSelected(value);
    }

    private loadProjects() {
        projectWebservice
            .load()
            .then((response) => {
                // Directly sort the projects by bkp
                this.$store.commit('project/setProjects', response.data);
                const stillExists = this.projects.some((p) => this.selectedProject && p.id === this.selectedProject.id);
                if (!stillExists) {
                    this.$store.commit('project/setSelectedProject', ProjectStore.defaultProject);
                }
                this.setDefaultProject();
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private setDefaultProject() {
        if (this.projects.length > 0) {
            // The selectedProject is initialized, therefor check if the users are 0.
            // They are never zero if it's a user created project.
            if (!this.selectedProject.users || this.selectedProject.users.length === 0) {
                projectWebservice
                    .loadOneByUser(this.projects[0].id)
                    .then((response) => {
                        this.$store.commit('project/setSelectedProject', response.data);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            } else {
                const currentProject = this.projects.find((project) => {
                    return project.id === this.selectedProject.id;
                });
                if (!currentProject) {
                    return;
                }
                projectWebservice
                    .loadOneByUser(currentProject.id)
                    .then((response) => {
                        this.$store.commit('project/setSelectedProject', response.data);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        }
    }

    private projectSelected(project) {
        projectWebservice
            .loadOneByUser(project.id)
            .then((response) => {
                this.$store.commit('project/setSelectedProject', response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private getProjectTitle(project: Project) {
        if (project && project.title !== '') {
            let title = project.title;
            if (project.company) {
                title += ' (' + project.company.name + ')';
            }
            if (project.parent_project) {
                title += ' (' + this.$t('labels.inheritedProject') + ')';
            }
            return title;
        } else {
            return this.$t('labels.newProject');
        }
    }

    get selectedProjectTitle() {
        return this.getProjectTitle(this.selectedProject);
    }
}
